import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkle, Heart } from "lucide-react";
import { getProfile } from "@/lib/profile";
import { armOpeningSound, startOpeningSound } from "@/lib/openingSound";
import { startWaves, stopWaves } from "@/lib/ambiance";

const EASE = [0.22, 1, 0.36, 1];

export default function Gate() {
  const navigate = useNavigate();

  // Profil déjà connu sur cet appareil : on entre directement
  useEffect(() => {
    armOpeningSound();
    startWaves();
    if (getProfile()) navigate("/accueil", { replace: true });
    return () => stopWaves();
  }, [navigate]);

  return (
    <>
      <header className="rav-hero">
        <span className="rav-branch rav-branch-left" aria-hidden="true" />
        <span className="rav-branch rav-branch-right" aria-hidden="true" />
        <motion.div
          className="rav-emblem-wrap"
          data-testid="gate-emblem"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: EASE }}
        >
          <div className="rav-halo" />
          <img
            src="/logo-accueil.webp"
            alt="Respire Aime Vibre — Julie Pomares Durand, Sophrologue"
            className="rav-logo-img"
            draggable="false"
          />
        </motion.div>
        <motion.h1
          className="rav-tagline"
          data-testid="gate-tagline"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.15, ease: EASE }}
        >
          L’Instant qui vous ressemble
        </motion.h1>
        <motion.div
          className="rav-divider"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: EASE }}
        >
          <img src="/divider-heart.webp" alt="" aria-hidden="true" className="rav-divider-img" />
        </motion.div>
      </header>

      <main className="rav-content" data-testid="gate-page">
        <motion.div
          className="rav-connexion-body"
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35, ease: EASE }}
        >
          <h2 className="rav-page-title" data-testid="gate-title">Bienvenue</h2>
          <button
            type="button"
            className="rav-primary-button"
            data-testid="gate-new-button"
            onClick={() => {
              startOpeningSound(); // le gong part ICI, sur ce bouton
              navigate("/bienvenue");
            }}
          >
            <Sparkle size={17} strokeWidth={1.6} />
            Je découvre, c'est ma première visite
          </button>
          <p className="rav-gate-free" data-testid="gate-free-note">
            Inscription gratuite
            <br />
            1 semaine offerte — sans carte bancaire
            <br />
            <strong>(7 Instants à créer librement)</strong>
          </p>
          <p className="rav-page-sub" data-testid="gate-sub">Avez-vous déjà votre espace Respire Aime Vibre ?</p>
          <button
            type="button"
            className="rav-secondary-button rav-gate-btn"
            data-testid="gate-known-button"
            onClick={() => navigate("/connexion?mode=login")}
          >
            <Heart size={19} strokeWidth={1.6} />
            J'ai déjà mon espace
          </button>
        </motion.div>
      </main>
    </>
  );
}
